/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedModuleOutput } from './exportedModuleOutput';

export type GenericApiResponseExportedModuleData = ExportedModuleOutput | null;
